export default [{
  path: '/wage',
  name: 'wage',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/wage/index')
}]
